import { render, staticRenderFns } from "./ArticleItems.vue?vue&type=template&id=5822dac3&scoped=true&"
import script from "./ArticleItems.vue?vue&type=script&lang=js&"
export * from "./ArticleItems.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItems.vue?vue&type=style&index=0&id=5822dac3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822dac3",
  null
  
)

export default component.exports